enum CritEnum {
    Ourson = "992",
    Flocon = "993",
    _1ere_etoile = "994",
    _2eme_etoile = "995",
    _3eme_etoile = "996",
    Economique = "997",
    Débutant = "998",
    Confirmé = "999",
    Premium = "1000",
    Chaussures = "1001",
    Battons = "1002",
    Snowboard = "1014",
    Ski = "1015",
    Piou_Piou = "1016",
    Matinée = "1017",
    Après_Midi = "1018",
    Journée = "1019",
    Collectif = "1020",
    Panier_Gastronomique = "1021",
    Panier_Savoyard = "1022",
    Panier_Gourmand = "1023",
    Panier_Hallal = "1024",
    Panier_Enfant = "1025",
    Panier_Végétarien = "1026",
    Panier_Repas = "1027",

    Champion = "1030",
    Espoir = "1031",
    Mini_Kid = "1032",
    Bronze = "1038",
    first_class = "1039",
    second_class = "1040",
    level_0 = "1058",
    level_1 = "1059",
    level_2 = "1060",
    level_3 = "1061",
    level_4 = "1062",
    level_5 = "1063",

    SANS = '1013',
    SMILEPASS = "700"
}

export default CritEnum